import React, { useEffect, useRef } from 'react'
import slideAcross from '../utils/slide'

function Vission() {
	const slide = useRef()

	useEffect(() => {
		slideAcross([slide.current])
	}, [])

	return (
		<section className='vission' data-aos='fade-up'>
			<div className='vission__content'>
				<h2 className='vission__title' ref={slide} data-slide='right'>
					Visión
				</h2>
				<div className='vission__text' data-aos='fade-left'>
					<p>
						<span className='upper'>
							Hacer que la administración de inversiones sea fácil y rentable para nuestros
							clientes.
						</span>
					</p>
					<p>Somos la administradora de inversiones que más valor crea en Mendoza.</p>
					<p>Queremos administrar 5.000 inversiones para el 2025.</p>
					<p>
						Los clientes nos eligen y prefieren porque la calidad de nuestros servicios aumentan su
						rentabilidad.
					</p>
					<p>
						Logramos, a través de una cultura de servicio, gestionar y facilitar la comunicación,
						siendo eficientes en el uso de los recursos.
					</p>
				</div>
			</div>
		</section>
	)
}

export default Vission
